<template>
  <v-card class="cardBody" color="white" v-if="logueado">
    <p class="text-center mt-5 display-1 font-weight-medium">
      SOLICITUD DE GRABACION DE LLAMADAS.
    </p>
    <v-breadcrumbs :items="itemsBreadcrumbs" divider="/"></v-breadcrumbs>
    <v-row align="center" class="mx-1">
      <v-col cols="12" md="5">
        <v-img
          class="mx-auto"
          :src="require('@/assets/logo.jpg')"
          :width="$vuetify.breakpoint.mdAndDown ? 150 : 400"
        ></v-img>
      </v-col>
      <v-col cols="12" md="7">
        <v-card>
          <v-card-title
            class="text-h6 font-weight-regular justify-space-between"
          >
            <span>{{ currentTitle }}</span>
            <v-avatar
              color="primary lighten-2"
              class="subheading white--text"
              size="24"
              >{{ step }}</v-avatar
            >
          </v-card-title>

          <v-window v-model="step">
            <v-window-item :value="1">
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="fechaSolicitud"
                      label="Fecha y hora de solicitud"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="fechaAsistencia"
                      label="Fecha y hora de asistencia"
                      type="date"
                      step="1"
                      :rules="[rules.required]"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="numeroAsistencia"
                      label="Numero de asistencia"
                      :rules="[rules.required]"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-window-item>

            <v-window-item :value="2">
              <v-card-text>
                <v-row>
                  <v-col cols="6" class="py-0">
                    <v-text-field
                      v-model="nombre"
                      label="Nombre"
                      outlined
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-text-field
                      v-model="placa"
                      label="Placa del vehículo"
                      outlined
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0">
                    <v-text-field
                      v-model="marca"
                      label="Marca del vehículo"
                      outlined
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0">
                    <v-text-field
                      v-model="modelo"
                      label="Modelo del vehículo"
                      outlined
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-window-item>

            <v-window-item :value="3">
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      v-model="solicitadaNombre"
                      label="Solicitada por nombre"
                      disabled
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-textarea
                      v-model="motivoSolicitud"
                      label="Motivo de petición de llamada"
                      outlined
                      auto-grow
                      :rules="[rules.required]"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-window-item>

            <v-window-item :value="4">
              <v-card-text>
                <VueFileAgent
                  v-model="fileRecords"
                  :deletable="true"
                  :multiple="true"
                  :meta="true"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                ></VueFileAgent>
              </v-card-text>
            </v-window-item>
          </v-window>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn :disabled="step === 1" text @click="step--"> Back </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="step === 4"
              color="primary"
              depressed
              @click="step++"
            >
              Siguiente
            </v-btn>
            <v-btn
              :disabled="step != 4"
              color="primary"
              depressed
              @click="guardar()"
            >
              Enviar
            </v-btn>
          </v-card-actions>

          <v-overlay v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
  <v-card v-else flat class="mx-auto my-auto">
    <div class="mt-5 display-1 text-center">Pagina no disponible</div>
    <v-card-text>
      <lottie-player
        autoplay
        mode="normal"
        src="https://assets5.lottiefiles.com/packages/lf20_shvej97v.json"
        style="width: 300px"
        background="transparent"
      >
      </lottie-player>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  dbRealtimeSoliGrabaciones,
  dbRealtimeUser,
  instanceWeb,
  dbStorage,
} from "../main";
import "@lottiefiles/lottie-player";
import axios from "axios";
import router from "../router";

export default {
  data() {
    return {
      step: 1,
      fileRecords: [],
      uploadUrl: "",
      uploadHeaders: { "X-Test-Header": "vue-file-agent" },
      fileRecordsForUpload: [],
      //variables formulario
      idUsuario: "",
      fechaSolicitud: null,
      fechaAsistencia: null,
      numeroAsistencia: null,
      nombre: null,
      placa: null,
      marca: null,
      modelo: null,
      solicitadaNombre: null,
      motivoSolicitud: null,
      itemsBreadcrumbs: [
        {
          text: "Inicio",
          disabled: false,
          href: "login",
        },
        {
          text: "Mis solicitudes",
          disabled: false,
          href: "SolicitudGrabaciones",
        },
        {
          text: "Nuevas solicitud",
          disabled: true,
          href: "TicketsAssa",
        },
      ],
      logueado: false,
      cuenta: "",
      rules: {
        required: (value) => !!value || "Campo requerido.",
      },
      overlay: false,
      //telegram
      chatIdGrupo: -1001512403640,
      chatIdUsuario: 0,
      token: "5024387664:AAGrXKGayYOFsALSYEYkHseAPe2TgZbFjF4",
    };
  },
  created() {
    this.verificarAuth();
    this.inicializar();
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Datos de solicitud";
        case 2:
          return "Datos del asegurado";
        default:
          return "Motivo";
      }
    },
  },
  methods: {
    verificarAuth() {
      let me = this;
      instanceWeb.auth().onAuthStateChanged(function (user) {
        if (user) {
          me.datosUsuario(user.uid);
        } else {
          me.cerrarSesion();
        }
      });
    },

    datosUsuario(id) {
      let me = this;
      dbRealtimeUser
        .child(id)
        .once("value")
        .then(function (dataSnapshot) {
          if (dataSnapshot.val().estado == "activo") {
            me.logueado = true;
            me.idUsuario = dataSnapshot.key;
            me.cuenta = dataSnapshot.val().cuenta;
            me.solicitadaNombre = dataSnapshot.val().nombre;
            me.chatIdUsuario = dataSnapshot.val().idTelegram;
          } else {
            me.cerrarSesion();
          }
        });
    },

    cerrarSesion() {
      instanceWeb.auth().signOut();
      this.logueado = false;
      router.push({ name: "Login" });
    },

    inicializar() {
      this.fechaSolicitud =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
    },

    guardar() {
      let me = this;
      if (
        me.fechaSolicitud != null &&
        me.fechaAsistencia != null &&
        me.numeroAsistencia != null &&
        me.nombre != null &&
        me.placa != null &&
        me.marca != null &&
        me.modelo != null &&
        me.solicitadaNombre != null &&
        me.motivoSolicitud != null
      ) {
        dbRealtimeSoliGrabaciones
          .child(this.cuenta)
          .child(this.numeroAsistencia)
          .set({
            idUsuario: this.idUsuario,
            fechaSolicitud: this.fechaSolicitud,
            fechaAsistencia: this.fechaAsistencia,
            numeroAsistencia: this.numeroAsistencia,
            nombre: this.nombre,
            placa: this.placa,
            marca: this.marca,
            modelo: this.modelo,
            solicitadaNombre: this.solicitadaNombre,
            motivoSolicitud: this.motivoSolicitud,
            cuenta: this.cuenta,
            estado: "En proceso",
          })
          .then(function () {
            me.notificacionTelegram();
            if (me.fileRecordsForUpload.length > 0) {
              me.cargarArchivos();
            } else {
              me.irTablaSolicitudGrabacion();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.$toast.info("Debe de completar todos los campos");
      }
    },

    notificacionTelegram() {
      let mensaje =
        "SE HA GENERADO UNA NUEVA SOLICITUD DE GRABACION DE LLAMADA" +
        "%0A" +
        "Fecha solicitud: " +
        this.fechaSolicitud +
        "%0A" +
        "Fecha asistencia: " +
        this.fechaAsistencia +
        "%0A" +
        "Numero asistencia: " +
        this.numeroAsistencia +
        "%0A" +
        "Nombre asegurado: " +
        this.nombre +
        "%0A" +
        "Placa: " +
        this.placa +
        "%0A" +
        "Marca: " +
        this.marca +
        "%0A" +
        "Modelo: " +
        this.modelo +
        "%0A" +
        "Solicitada por nombre: " +
        this.solicitadaNombre +
        "%0A" +
        "motivo de petición: " +
        this.motivoSolicitud;

      axios
        .post(
          "https://api.telegram.org/bot" +
            this.token +
            "/sendMessage?chat_id=" +
            this.chatIdGrupo +
            "&text=" +
            mensaje
        )
        .then((response) => {
          //console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });

      axios
        .post(
          "https://api.telegram.org/bot" +
            this.token +
            "/sendMessage?chat_id=" +
            this.chatIdUsuario +
            "&text=" +
            mensaje
        )
        .then((response) => {
          //console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },

    irTablaSolicitudGrabacion() {
      this.$router.push("/SolicitudGrabaciones");
    },

    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords);
    },
    cargarArchivos: function () {
      let me = this;
      me.overlay = true;
      let cont = me.fileRecordsForUpload.length;
      for (var i = 0; i < me.fileRecordsForUpload.length; i++) {
        dbStorage
          .ref(
            "SolicitudesGrabaciones/" +
              me.cuenta +
              "/" +
              "ArchivosMotivos" +
              "/" +
              me.numeroAsistencia +
              "/" +
              me.fileRecordsForUpload[i].file.name
          )
          .put(me.fileRecordsForUpload[i].file)
          .then(function () {
            me.$toast.info("Archivo cargados!");
            if (cont <= i) {
              me.overlay = false;
              me.irTablaSolicitudGrabacion();
            }
          })
          .catch(function (error) {
            console.log("ERROR", error);
          });
      }
    },
    onBeforeDelete: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
        }
      }
    },
  },
};
</script>

<style>
.cardBody {
  height: 100%;
  width: 100%;
}
</style>